import QuickEnum from "../enum/QuickEnum";

const QuickNameMap = {
    [QuickEnum.QUICK_MERGE_PARENT_ORDER]: "合并订单",
    [QuickEnum.QUICK_NOT_MERGE_ORDER]: "非合并订单",
    [QuickEnum.QUICK_REGION_BLACK_DELAY_SHIPPING]: "可延迟发货",
    [QuickEnum.QUICK_EXPEDITE_DELIVERY]: "催发货订单",
    [QuickEnum.QUICK_CASH_DELIVERY]: "货到付款订单",
    [QuickEnum.QUICK_ONLINE_PAY]: "在线支付订单",
    [QuickEnum.QUICK_MANUAL_MERGER]: "需手工合并订单",
    [QuickEnum.QUICK_SPLIT_CHILD_ORDER]: "拆分订单",
    [QuickEnum.QUICK_HAS_BUYER_REMARK]: "有买家留言",
    [QuickEnum.QUICK_HAS_SELLER_REMARK]: "有卖家备注",
    [QuickEnum.QUICK_HAS_ANY_REMARK]: "有买家留言或卖家备注",
    [QuickEnum.QUICK_HAS_NO_REMARK]: "无备注无留言",
    [QuickEnum.QUICK_HAS_SUPPLIER_REMARK]: "有代发备注",
    [QuickEnum.QUICK_COUNTRY_ORDER]: "镇乡村订单",
    [QuickEnum.QUICK_NO_COUNTRY_ORDER]: "非乡村镇订单",
    [QuickEnum.QUICK_NO_SELF_PICKUP]: "非自提订单",
    [QuickEnum.QUICK_NOT_JD_FULFILLMENT]: "非京仓订单",
    [QuickEnum.QUICK_SHIPPING_FEE]: "包邮订单",
    [QuickEnum.QUICK_HAS_SHIPPING_FEE]: "有运费订单",
    [QuickEnum.QUICK_PART_SHIP]: "部分发货",
    [QuickEnum.QUICK_PART_CANCELED]: "部分取消",
    [QuickEnum.QUICK_WAYBILL_NO_INPUTED]: "已录入运单号",
    [QuickEnum.QUICK_WAYBILL_NO_UNINPUTED]: "未录入运单号",
    [QuickEnum.QUICK_DELIVERY_TIMEOUT]: "即将发货超时订单",
    [QuickEnum.QUICK_SEND_ABOUT_TO_OVERDUE]: "发货即将超时订单",
    [QuickEnum.QUICK_SHIP_BY_SF]: "加运费发顺丰",
    [QuickEnum.QUICK_DESIGNATED_LOGISTICS_COMPANY]: "指定物流",
    [QuickEnum.QUICK_HAS_GIFT]: "有赠品订单",
    [QuickEnum.QUICK_ALI_DELIVERY_GUARANTEE]: "阿里官方直送",
    [QuickEnum.QUICK_SINGLE_SKU_SINGLE_PIECE]: "单款单件",
    [QuickEnum.QUICK_SINGLE_SKU_MULTI_PIECE]: "单款多件",
    [QuickEnum.QUICK_MULTI_SKU]: "多款多件",
    [QuickEnum.QUICK_MULTI_WAYBILL]: "多运单号",
    [QuickEnum.QUICK_CANCEL_WAYBILL_RECYCLED]: "有回收运单号",
    [QuickEnum.QUICK_SHIPPING_DEADLINE_OVERDUE]: "超时订单",
};

export default QuickNameMap;
